import type { Message } from '@/common/components/wavvest-planning/types';
import { GUIDED_MODE_V2_CATEGORIES } from '@/common/components/wavvest-planning/guided-mode-components/v2-category-config';

const suggestedPromptTextToName = (() => {
  const prompts = new Map<string, string>();
  for (const category of GUIDED_MODE_V2_CATEGORIES) {
    for (const { name, prompt } of category.suggestedPrompts) {
      prompts.set(prompt.trim(), name);
    }
  }
  return prompts;
})();

export function replaceSuggestedPromptsWithNames(messages: Message[]): Message[] {
  return messages.map((message) => {
    if (message.sender !== 'human') return message;
    const displayName = suggestedPromptTextToName.get(message.content.trim());
    return displayName != null ? { ...message, content: displayName } : message;
  });
}
